function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "icon_adres",
  d: "M9.32,2.44A5.01,5.01,0,0,0,7.5.66,4.919,4.919,0,0,0,5,0,4.919,4.919,0,0,0,2.5.66,5.01,5.01,0,0,0,.68,2.44,4.6,4.6,0,0,0,0,4.88,4.44,4.44,0,0,0,.21,6.31,7.444,7.444,0,0,0,1.02,7.9C1.29,8.32,5,13,5,13S8.71,8.32,8.98,7.89A7.22,7.22,0,0,0,9.79,6.3,4.376,4.376,0,0,0,10,4.88,4.6,4.6,0,0,0,9.32,2.44ZM5,7A2,2,0,1,1,7,5,2.006,2.006,0,0,1,5,7Z"
});

var SvgMarker = function SvgMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marker.72397b05.svg";
export { ForwardRef as ReactComponent };